import * as React from "react";
import Host from "./Host";
function HostPositioner(_a) {
  var host = _a.host;
  return /*#__PURE__*/React.createElement("div", {
    id: "sender_".concat(host.id),
    className: "hostbox c-host-grid__card " + (host.status !== "free" ? "incall" : ""),
    style: {
      transform: "translate(".concat(host.left, "px, ").concat(host.top, "px)")
    }
  }, /*#__PURE__*/React.createElement(Host, {
    host: host
  }));
}
export default HostPositioner;